export const getRegionsMessage = (regions: {name: string}[] | undefined, distance: number) => {
    const regionNames = regions?.map(({name}: {name: string}) => name) || [];

    if (regionNames.length) {
        return `${regionNames.join(", ")}${distance !== 0 ? `(+${distance || 5}km)` : ""}`;
    }

    return "";
};
export const getRegionsMessage = (regions: {name: string}[] | undefined, distance: number) => {
    const regionNames = regions?.map(({name}: {name: string}) => name) || [];

    if (regionNames.length) {
        return `${regionNames.join(", ")}${distance !== 0 ? `(+${distance || 5}km)` : ""}`;
    }

    return "";
};
